import React from "react";

// Layered blurred syrup-like orbs. Pure CSS, respects reduced motion via .animate-orb.
export default function FluidBackground({ variant = "default" }) {
  const orbs =
    variant === "warm"
      ? [
          { c: "#FF8C00", s: 420, top: "-10%", left: "-8%", d: "0s" },
          { c: "#FF3B2F", s: 360, top: "30%", right: "-10%", d: "3s" },
          { c: "#FFD700", s: 300, bottom: "-12%", left: "20%", d: "6s" },
        ]
      : [
          { c: "#210D3D", s: 520, top: "-15%", left: "-10%", d: "0s" },
          { c: "#00CED1", s: 340, top: "40%", right: "-12%", d: "4s" },
          { c: "#B19CD9", s: 300, bottom: "-10%", left: "10%", d: "7s" },
          { c: "#FF8C00", s: 260, top: "10%", right: "25%", d: "2s" },
        ];
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {orbs.map((o, i) => (
        <div
          key={i}
          className="absolute rounded-full animate-orb"
          style={{
            width: o.s, height: o.s, background: o.c, filter: "blur(100px)",
            opacity: 0.45, top: o.top, left: o.left, right: o.right, bottom: o.bottom,
            animationDelay: o.d,
          }}
        />
      ))}
    </div>
  );
}
